<template>
<div v-if="data_courses[0]">
<div v-if="isLoading" class="loading">Loading&#8230;</div> 





<div class="columns is-gapless has-background-info-light">
<div class="column is-3 mt-2 has-text-weight-bold is-size-4">&nbsp;&nbsp;COURSES</div>

<div class="column is-2">
<div class="columns is-gapless">  
  <div class="column is-10 control has-icons-left">
    <input  v-model="search" @keyup.enter="get_courses()" class="input is-fullwidth has-text-weight-bold" type="text" placeholder="search code">
    <span class="icon is-small is-left"><i class="fas fa-search" aria-hidden="true"></i></span>
  </div>

  <div class="column is-2 has-text-weight-light is-size-6" style="margin-bottom:-.2em;"> 
      <button @click="filter_search_clear()" class="button has-background-danger-light"><span class="icon is-small has-text-grey"> <i class="fas fa-times"></i> </span></button>
  </div>

</div></div>

<div class="column is-1"></div>

<div class="column is-3">
<div class="columns is-gapless"> 

<div class="column is-2 is-size-7 has-text-right has-text-weight-bold">Filter&nbsp;&nbsp;<br>Program&nbsp;&nbsp;</div>
<div class="column is-8">
    <div class="select is-info is-fullwidth has-text-weight-bold">
        <select  @change="filter_program()" id="program" class="has-text-weight-bold has-text-danger" v-model="prog_id">
                <option v-for="(choice,index) in data_programs" :value="choice.prog_ID" :key="index">{{ choice.prog_CODE }} : {{choice.prog_CODEPLUS}}</option>
        </select>
    </div>                
</div>

  <div class="column is-2 has-text-weight-light is-size-6" style="margin-bottom:-.2em;"> 
      <button @click="filter_program_clear()" class="button has-background-danger-light"><span class="icon is-small has-text-grey"> <i class="fas fa-times"></i> </span></button>
  </div>

</div></div>





<div class="column is-1"></div>

    <div class="column is-2">
        <button @click="course_new()" class="button is-fullwidth has-background-success has-text-white">
            <span class="icon"><i class="fas fa-plus"></i></span>     
        </button> 
    </div>


</div>




<!-- //COURSES  -->
<div class="columns is-centered is-multiline is-gapless" style="margin-bottom:1em;">
<div class="column is-11 box has-background-light">
<div class="columns is-centered is-multiline is-gapless">
  <div class="column is-10" v-for="(data,index) in data_courses" :key="index">
  <CompPedCourseCourse :data="data" :key="randomKey()">  </CompPedCourseCourse>
  </div>
</div></div>


 

</div>
<!-- END COURSES  -->

</div>
</template>

<script>
import axios from 'axios'
import CompPedCourseCourse from "@/views/Admin/Comp_Admin_Ped_Course_Course"

export default {
  name: 'AdminPedCoursePond',
  props: [ ],
  components: {CompPedCourseCourse},


    data() {
        return {
            isLoading:false,
            search:'',
            prog_id:-1,
            data_courses:[],
            data_programs:[],
            cour_id:0,
            key_pond:0, // UNIQUE KEY
        }
    },


created() {
    this.isLoading=true;
    // GET PROGRAMS
    var sql = "SELECT * FROM MyMEQ_PROGRAM WHERE prog_ACTIVE = 1 ORDER BY prog_TITRE_F"
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
    .then(res => { 
        this.data_programs = res.data
        this.isLoading=false;  
        this.get_courses()
      })


     
},



methods: {

filter_search_clear:function() {
  this.search = ''
  this.get_courses()
},

filter_program_clear:function() {
  this.prog_id = -1
  this.get_courses()
},

filter_program:function() {
var index = document.getElementById("program").selectedIndex
  this.prog_id = this.data_programs[index].prog_ID
  this.get_courses()
},

course_search:function() {

},


course_new:function() {
// CALLED FROM ADMIN_PED !!!!

// CHECK IF NOTHING
if (this.data_courses.length == 0) {
    this.data_courses.unshift(
    {cour_ID:0 , isChanged:0 , doDelete:0, showDetails:0 , cour_CODE:'',cour_TITRE_F:'',cour_TITRE_E:'',cour_UNITS:'', cour_HOURS:0, cour_COST:'' }
    )
  ;return;}


if (this.data_courses[0].cour_ID == 0) {return;}// CHECK IF ALREADY ONE NEW

// HERE -- ALL GOOD ??
  this.data_courses.unshift(
    {cour_ID:0 , isChanged:0 , doDelete:0, showDetails:0 , cour_CODE:'',cour_TITRE_F:'',cour_TITRE_E:'',cour_UNITS:'', cour_HOURS:0, cour_COST:'' }
  )
},



course_delete_cancel:function(index) {
  this.data_courses[index].doDelete = false
},

course_changed:function(index) {
  this.data_courses[index].isChanged = true
},

course_delete_confirm:function(index) {
  this.data_courses[index].doDelete = true 
},




course_delete_execute:function(index) {

var query

// NEED TO CHECK IF REMOVING FROM PROG/COMP !!!! 



if (this.prog_id != 0) 
{query = 'DELETE FROM MyMEQ_RELATION WHERE prog_ID = ' + this.prog_id + " AND cour_ID = " + this.data_courses[index].cour_ID  

  axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
  .then(res => { 
      this.data_courses.splice(index,1)
      this.$snotify.success('DELETED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
  });

} // DELETE FROM THE PROGRAM (NO AEC)


else if (this.comp_id != 0) 
{ query = 'DELETE FROM MyMEQ_COMPETENCE_DETAILS WHERE comp_ID = ' + this.comp_id + ' AND cour_ID = ' + this.data_courses[index].cour_ID
  axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
  .then(res => { 
      this.data_courses.splice(index,1)
      this.$snotify.success('DELETED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
  });

} // DELETE FROM THE COMPETENCE
else {

  // CHECK IF NOT SAVED
  if (this.data_courses[index].cour_ID == 0) {this.data_courses.splice(index,1); return;}
// REMOVE FROM DB
  query = "DELETE FROM myMEQ_COUR WHERE cour_ID = " + this.data_courses[index].cour_ID
  axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
  .then(res => { 
      this.data_courses.splice(index,1)
      this.$snotify.success('DELETED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
  });

} // END CHECK DELETE WHAT

},

get_courses:function() {
// GET COURSE LIST
  this.isLoading = true;

var querySearch1 = ''
var querySearch2 = ''
if (this.search.trim() != '') {
    querySearch1 = " AND cour_CODE LIKE '%25" + this.search + "%25' "
    querySearch2 = " WHERE cour_CODE LIKE '%25" + this.search + "%25' "
}


// CHECK IF WE ARE GETTING BY PROG/COMP
var query = ''
// var queryWhere = 'SELECT * FROM MyMEQ_RELATION INNER JOIN MyMEQ_COUR ON MyMEQ_RELATION.cour_ID = MyMEQ_COUR.cour_ID'
if (this.prog_id != -1) {query = "SELECT distinct MyMEQ_COUR.* FROM MyMEQ_RELATION INNER JOIN MyMEQ_COUR ON MyMEQ_RELATION.cour_ID = MyMEQ_COUR.cour_ID WHERE prog_ID = " + this.prog_id + querySearch1 + "  ORDER BY cour_CODE"}
// else if (this.comp_id != 0) {query = "SELECT MyMEQ_COUR.*, 0 as isChanged, 0 as doDelete, 0 as showDetails FROM MyMEQ_COMPETENCE INNER JOIN MyMEQ_COMPETENCE_DETAILS ON MyMEQ_COMPETENCE.comp_ID = MyMEQ_COMPETENCE_DETAILS.comp_ID INNER JOIN MyMEQ_COUR ON MyMEQ_COMPETENCE_DETAILS.cour_ID = MyMEQ_COUR.cour_ID WHERE MyMEQ_COMPETENCE.comp_ID = " + this.comp_id + "  ORDER BY cour_CODE"}
else {query = "SELECT *, 0 as isChanged, 0 as doDelete, 0 as showDetails FROM myMEQ_COUR " + querySearch2 + " ORDER BY cour_CODE"}
console.log(query)
//   var query = "SELECT *, 0 as isChanged, 0 as doDelete FROM myMEQ_COUR"
  axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
  .then(res => { 
      this.data_courses = res.data
      this.isLoading = false;
  });
},

course_save:function(index) {

var query
if (this.data_courses[index].cour_ID == 0) {
  // INSERT
      query = "INSERT INTO MyMEQ_COUR (cour_CODE) VALUES ('');SELECT MAX(cour_ID) AS newID FROM MyMEQ_COUR"
      axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
      .then(res => { 
          this.data_courses[index].cour_ID = res.data[0].newID

var dCost = this.data_courses[index].cour_COST || 0 


          query = "UPDATE myMEQ_COUR SET " 
          query +=  " cour_CODE = '" + this.data_courses[index].cour_CODE
          query +=  "', cour_TITRE_F = '" + this.data_courses[index].cour_TITRE_F.trim().replace(/'/g,"''")
          query +=  "', cour_TITRE_E = '" + this.data_courses[index].cour_TITRE_E.trim().replace(/'/g,"''")
          query +=  "', cour_UNITS = '" + this.data_courses[index].cour_UNITS
          query +=  "', cour_HOURS = " + this.data_courses[index].cour_HOURS
          query +=  ", cour_COST = " + dCost
          query +=  " WHERE cour_ID = " + this.data_courses[index].cour_ID

          axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
          .then(res => { 
              this.$snotify.success('SAVED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
              this.data_courses[index].isChanged = false
          });
  });
}
else // UPDATE
{ 
          query = "UPDATE myMEQ_COUR SET " 
          query +=  " cour_CODE = '" + this.data_courses[index].cour_CODE
          query +=  "', cour_TITRE_F = '" + this.data_courses[index].cour_TITRE_F.trim().replace(/'/g,"''")
          query +=  "', cour_TITRE_E = '" + this.data_courses[index].cour_TITRE_E.trim().replace(/'/g,"''")
          query +=  "', cour_UNITS = '" + this.data_courses[index].cour_UNITS
          query +=  "', cour_HOURS = " + this.data_courses[index].cour_HOURS
          query +=  ", cour_COST = " + this.data_courses[index].cour_COST
          query +=  " WHERE cour_ID = " + this.data_courses[index].cour_ID
          axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
          .then(res => { 
              this.$snotify.success('SAVED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
              this.data_courses[index].isChanged = false
          });

}

},
// END SAVE 

// GENERATE A NEW ID! 
randomKey:function() {
return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
});},

check_mobile() {
// RETURN COLLEGE NAME - SHORT FOR MOBILE
if (sessionStorage.getItem('isMobile') == 'true')
  {return true}
  else {return false}
},
return_column_width(colD, colM) {
if (sessionStorage.getItem('isMobile') == 'true')
  {return colM} else {return colD} 
},
return_text_size(sizeD, sizeM) {
if (sessionStorage.getItem('isMobile') == 'true')
  {return sizeM} else {return sizeD} 
},



}

}
</script>


<style scoped>

</style>